import React from "react";
import { motion } from "framer-motion";
import Header from "../components/Header"; // Import the Header component
import Footer from "../components/Footer";

const About = () => {
  return (
    <div className="min-h-screen flex flex-col bg-black text-rose-300">
      {/* Header Section */}
      <Header />

      {/* Main Content */}
      <div className="flex flex-grow pt-24 pb-12 px-4 md:px-8 justify-center items-center">
        <motion.div
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="glass w-full max-w-lg text-center"
        >
          {/* About Title */}
          <motion.h2
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            className="text-3xl md:text-5xl font-extrabold mb-6 tracking-wide leading-tight"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            About <span className="text-white">Our Shop</span>
          </motion.h2>

          {/* About Description */}
          <motion.p
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            className="text-base md:text-lg mb-8 leading-relaxed"
          >
            We bring you the latest fashion trends to make you stand out. Our
            goal is to offer the best selection of high-quality clothing and
            accessories.
          </motion.p>
        </motion.div>
      </div>

      {/* Footer Section */}
      <Footer />
    </div>
  );
};

export default About;
